import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, FilterIcon, MapPinIcon, DollarSignIcon, BriefcaseIcon } from 'lucide-react';
import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import ThemeToggle from '../components/ui/ThemeToggle';
const JobFeed: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const featuredJobs = [{
    id: '1',
    title: 'Senior React Developer',
    company: 'SpaceX',
    logo: 'https://logo.clearbit.com/spacex.com',
    location: 'Remote',
    salary: '$120k - $150k',
    tags: ['Remote', 'Full-time'],
    posted: '2 days ago',
    featured: true
  }, {
    id: '2',
    title: 'Product Designer',
    company: 'NASA',
    logo: 'https://logo.clearbit.com/nasa.gov',
    location: 'Houston, TX',
    salary: '$90k - $120k',
    tags: ['Hybrid', 'Full-time'],
    posted: '1 day ago',
    featured: true
  }, {
    id: '3',
    title: 'Data Scientist',
    company: 'Blue Origin',
    logo: 'https://logo.clearbit.com/blueorigin.com',
    location: 'Seattle, WA',
    salary: '$110k - $140k',
    tags: ['On-site', 'Full-time'],
    posted: '3 days ago',
    featured: true
  }];
  const recentJobs = [{
    id: '4',
    title: 'Frontend Developer',
    company: 'Google',
    logo: 'https://logo.clearbit.com/google.com',
    location: 'Mountain View, CA',
    salary: '$100k - $130k',
    tags: ['On-site', 'Full-time'],
    posted: '1 day ago'
  }, {
    id: '5',
    title: 'UX Researcher',
    company: 'Apple',
    logo: 'https://logo.clearbit.com/apple.com',
    location: 'Cupertino, CA',
    salary: '$95k - $125k',
    tags: ['Hybrid', 'Full-time'],
    posted: '2 days ago'
  }, {
    id: '6',
    title: 'DevOps Engineer',
    company: 'Amazon',
    logo: 'https://logo.clearbit.com/amazon.com',
    location: 'Remote',
    salary: '$110k - $140k',
    tags: ['Remote', 'Full-time'],
    posted: '3 days ago'
  }, {
    id: '7',
    title: 'Mobile Developer',
    company: 'Microsoft',
    logo: 'https://logo.clearbit.com/microsoft.com',
    location: 'Redmond, WA',
    salary: '$105k - $135k',
    tags: ['On-site', 'Full-time'],
    posted: '1 day ago'
  }, {
    id: '8',
    title: 'Blockchain Engineer',
    company: 'Coinbase',
    logo: 'https://logo.clearbit.com/coinbase.com',
    location: 'Remote',
    salary: '$130k - $160k',
    tags: ['Remote', 'Full-time'],
    posted: '5 days ago'
  }];
  const handleJobClick = (id: string) => {
    navigate(`/jobs/${id}`);
  };
  const JobCard: React.FC<{
    job: any;
    featured?: boolean;
  }> = ({
    job,
    featured = false
  }) => {
    return <Card className={`mb-4 ${featured ? 'border-l-4 border-l-teal-500' : ''}`} hover onClick={() => handleJobClick(job.id)} data-id="element-249">
        <div className="flex items-start gap-3" data-id="element-250">
          <div className="h-12 w-12 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100 dark:bg-gray-700 flex items-center justify-center" data-id="element-251">
            {job.logo ? <img src={job.logo} alt={job.company} className="h-full w-full object-cover" data-id="element-252" /> : <BriefcaseIcon className="text-gray-400" data-id="element-253" />}
          </div>
          <div className="flex-1" data-id="element-254">
            <div className="flex justify-between items-start" data-id="element-255">
              <div data-id="element-256">
                <h3 className="font-semibold text-gray-900 dark:text-gray-100" data-id="element-257">
                  {job.title}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-258">
                  {job.company}
                </p>
              </div>
              {featured && <span className="bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-200 text-xs px-2 py-1 rounded-full" data-id="element-259">
                  Featured
                </span>}
            </div>
            <div className="mt-2 flex flex-wrap items-center gap-3 text-sm text-gray-500 dark:text-gray-400" data-id="element-260">
              <div className="flex items-center" data-id="element-261">
                <MapPinIcon size={14} className="mr-1" data-id="element-262" />
                {job.location}
              </div>
              <div className="flex items-center" data-id="element-263">
                <DollarSignIcon size={14} className="mr-1" data-id="element-264" />
                {job.salary}
              </div>
            </div>
            <div className="mt-3 flex justify-between items-center" data-id="element-265">
              <div className="flex gap-2" data-id="element-266">
                {job.tags.map((tag: string, index: number) => <span key={index} className={`text-xs px-2 py-1 rounded-full ${tag === 'Remote' ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200' : tag === 'Hybrid' ? 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200' : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'}`} data-id="element-267">
                    {tag}
                  </span>)}
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-268">
                {job.posted}
              </span>
            </div>
          </div>
        </div>
      </Card>;
  };
  return <div className="pb-20" data-id="element-269">
      <div className="bg-gradient-to-r from-teal-500 to-cyan-400 pt-12 pb-6 px-4" data-id="element-270">
        <div className="flex justify-between items-center mb-6" data-id="element-271">
          <h1 className="text-2xl font-bold text-white" data-id="element-272">Dredget</h1>
          <ThemeToggle data-id="element-273" />
        </div>
        <div className="relative" data-id="element-274">
          <Input placeholder="Search jobs, companies..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} icon={<SearchIcon size={18} data-id="element-276" />} fullWidth className="mb-0" data-id="element-275" />
          <button className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 bg-teal-500 rounded-lg text-white" onClick={() => setShowFilters(!showFilters)} data-id="element-277">
            <FilterIcon size={18} data-id="element-278" />
          </button>
        </div>
        {showFilters && <div className="mt-4 p-4 bg-white dark:bg-gray-800 rounded-xl shadow-md" data-id="element-279">
            <div className="grid grid-cols-2 gap-3" data-id="element-280">
              <div data-id="element-281">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-282">
                  Location
                </label>
                <select className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 py-2 px-3" data-id="element-283">
                  <option data-id="element-284">Anywhere</option>
                  <option data-id="element-285">Remote</option>
                  <option data-id="element-286">United States</option>
                  <option data-id="element-287">Europe</option>
                  <option data-id="element-288">Asia</option>
                </select>
              </div>
              <div data-id="element-289">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-290">
                  Job Type
                </label>
                <select className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 py-2 px-3" data-id="element-291">
                  <option data-id="element-292">All Types</option>
                  <option data-id="element-293">Full-time</option>
                  <option data-id="element-294">Part-time</option>
                  <option data-id="element-295">Contract</option>
                  <option data-id="element-296">Internship</option>
                </select>
              </div>
              <div data-id="element-297">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-298">
                  Experience
                </label>
                <select className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 py-2 px-3" data-id="element-299">
                  <option data-id="element-300">Any Experience</option>
                  <option data-id="element-301">Entry Level</option>
                  <option data-id="element-302">Mid Level</option>
                  <option data-id="element-303">Senior Level</option>
                  <option data-id="element-304">Executive</option>
                </select>
              </div>
              <div data-id="element-305">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-306">
                  Salary
                </label>
                <select className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 py-2 px-3" data-id="element-307">
                  <option data-id="element-308">Any Salary</option>
                  <option data-id="element-309">$50k+</option>
                  <option data-id="element-310">$75k+</option>
                  <option data-id="element-311">$100k+</option>
                  <option data-id="element-312">$150k+</option>
                </select>
              </div>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-313">
              <button className="text-sm text-teal-500 dark:text-teal-400 mr-4" data-id="element-314">
                Reset
              </button>
              <button className="text-sm bg-teal-500 text-white px-4 py-1.5 rounded-lg" data-id="element-315">
                Apply Filters
              </button>
            </div>
          </div>}
      </div>
      <div className="px-4 pt-6" data-id="element-316">
        <h2 className="text-lg font-semibold mb-4" data-id="element-317">Featured Jobs</h2>
        <div className="overflow-x-auto -mx-4 px-4 pb-4" data-id="element-318">
          <div className="flex space-x-4" style={{
          minWidth: 'max-content'
        }} data-id="element-319">
            {featuredJobs.map(job => <div key={job.id} className="w-80 flex-shrink-0" data-id="element-320">
                <JobCard job={job} featured data-id="element-321" />
              </div>)}
          </div>
        </div>
        <h2 className="text-lg font-semibold mb-4 mt-6" data-id="element-322">Recent Jobs</h2>
        <div data-id="element-323">
          {recentJobs.map(job => <JobCard key={job.id} job={job} data-id="element-324" />)}
        </div>
      </div>
    </div>;
};
export default JobFeed;